import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { TeamALayout } from '@/components/TeamALayout';
import { TeamAHome } from '@/pages/team-a/TeamAHome';
import { TeamAPublish } from '@/pages/team-a/TeamAPublish';
import { TeamAItemDetail } from '@/pages/team-a/TeamAItemDetail';
import { TeamASearch } from '@/pages/team-a/TeamASearch';
import { TeamACandidates } from '@/pages/team-a/TeamACandidates';
import { TeamAPickup, TeamAPickupIndex } from '@/pages/team-a/TeamAPickup';
import { TeamAStats } from '@/pages/team-a/TeamAStats';

function withLayout(Page: React.ComponentType) {
  return function Wrapped() {
    return (
      <TeamALayout>
        <Page />
      </TeamALayout>
    );
  };
}

const Home = withLayout(TeamAHome);
const Publish = withLayout(TeamAPublish);
const ItemDetail = withLayout(TeamAItemDetail);
const Search = withLayout(TeamASearch);
const Candidates = withLayout(TeamACandidates);
const PickupIndex = withLayout(TeamAPickupIndex);
const Pickup = withLayout(TeamAPickup);
const Stats = withLayout(TeamAStats);

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/item/:id" element={<ItemDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="/search/results" element={<Candidates />} />
        <Route path="/pickup" element={<PickupIndex />} />
        <Route path="/pickup/:id" element={<Pickup />} />
        <Route path="/stats" element={<Stats />} />

        {/* 兼容旧路径 */}
        <Route path="/verify" element={<Navigate to="/" replace />} />
        <Route path="/verify/:id" element={<Navigate to="/" replace />} />
        <Route path="/claim/:id" element={<Navigate to="/" replace />} />
        <Route path="/teacher/*" element={<Navigate to="/" replace />} />
        <Route path="/a/*" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
